import { HandbookV2 } from 'types'

export const articlesKeys = {
  prefix: 'articles',
  detail: (key: string, { password = null }: { password?: string | null } = {}) => [
    articlesKeys.prefix,
    'detail',
    key,
    { password },
  ],

  accesses: (key: string, handbook: HandbookV2 | null) => [[...articlesKeys.detail(key), handbook?.key, 'accesses']],
  users: (key: string, { permission }: { permission: string[] | null }) => [
    articlesKeys.prefix,
    key,
    'users',
    'list',
    { permission },
  ],
  // TODO: deprecate this and replace with above
  usersWithAccess: (key: string, handbook: HandbookV2 | null) => [
    articlesKeys.detail(key),
    handbook?.key,
    'users-access',
  ],

  updateStatus: (key: string) => [articlesKeys.prefix, key, 'update-status'],
  deepCopy: (key: string, workspaceId: string) => [articlesKeys.prefix, key, workspaceId, 'deep-copy'],
  aiSuggestionRequest: (key: string, layerId: string, id: number) => [
    articlesKeys.prefix,
    key,
    'aiSuggestionRequests',
    layerId,
    'detail',
    id,
  ],
}
